<template>
  <div class="collections-item-panel" v-if="inCreateCollectionMode">
    <SearchBar class="collection-item-search-bar"/>
    <SearchMenu class="collection-item-search"/>
    <div class="results-holder collection-results" id="collectionResults">
      <SearchResults type="resources" />
    </div>
  </div>
</template>

<script>

import {useRMTStore} from '@/store/RMTStore';
import {storeToRefs} from 'pinia/dist/pinia';
import {useIdentityStore} from '@/store/IdentityStore';
import SearchMenu from '@/components/libraries/search/SearchMenu';
import SearchBar from '@/components/libraries/SearchBar';
import SearchResults from '@/components/libraries/SearchResults';

export default {
  name: 'CollectionItemsPanel',
  components: {
    SearchMenu,
    SearchBar,
    SearchResults,
  },
  setup () {
    const RMTStore = useRMTStore();
    const { RMTSearchType, panelIsHidden, RMTPermission, RMTEditMode, inCreateCollectionMode } = storeToRefs(RMTStore);
    const identityStore = useIdentityStore();

    return {
      RMTStore,
      RMTSearchType,
      RMTPermission,
      RMTEditMode,
      panelIsHidden,
      identityStore,
      inCreateCollectionMode
    };

  },
  computed : {
    inUploadMode () {
      const RMTStore = useRMTStore();
      return RMTStore.inUploadMode;
    }
  }
};
</script>

<style scoped>
.collections-item-panel {
  position: absolute;
  width: inherit;
  height: 100%;
  background-color: #e3e3e3;
  z-index: 100;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  /*
  margin: 10px;
  */
  border-radius: 20px;
}

.collection-results {
  padding: 20px;
  overflow-y: auto;
  pointer-events: auto;
}

.collection-item-search {
  width: auto;
  height: auto;
}

.collection-item-search-bar {
  margin: 20px;
}
</style>